/* MCR · Brand film (<mcr-film>): the film is fetched only when a shopper presses play, then plays in a
   native <dialog> (Esc, backdrop click and the close button all close it and pause the film). */
(function () {
  if (customElements.get('mcr-film')) return;

  class McrFilm extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.video = this.dialog.querySelector('video');
      var self = this;
      this.querySelectorAll('[data-film-open]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.open(btn); });
      });
      this.dialog.querySelector('[data-film-close]').addEventListener('click', function () { self.dialog.close(); });
      this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.dialog.close(); });
      this.dialog.addEventListener('close', function () {
        self.video.pause();
        document.documentElement.classList.remove('mcr-lock');
        if (self.opener) self.opener.focus({ preventScroll: true });
      });
    }

    open(btn) {
      this.opener = btn;
      if (!this.video.src && this.video.dataset.src) this.video.src = this.video.dataset.src;
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
      document.documentElement.classList.add('mcr-lock');
      var p = this.video.play();
      if (p && p.catch) p.catch(function () {});
    }
  }
  customElements.define('mcr-film', McrFilm);
})();
